module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11705/img/storefront-header-blobs.svg"